export default {
    is_sale : {
        title : 'Продается',
        mask  : '{id[is_sale]Продается}'
    },
    is_rent : {
        title : 'Сдается в аренду',
        mask  : '{id[is_rent]Сдается в аренду}'
    },
    is_studio : {
        title : 'Студия',
        mask  : '{Студия id[is_studio]}'
    },
    count_of_rooms : {
        title : 'Количество комнат',
        mask  : '{комнат: id[count_of_rooms]}'
    },
    total_area : {
        title : 'Общая площадь',
        mask  : '{общая площадь: id[total_area] кв.м}'
    },
    living_area : {
        title : 'Жилая площадь',
        mask  : '{жилая площадь: id[living_area] кв.м}'
    },
    kitchen_area : {
        title : 'Площадь кухни',
        mask  : '{площадь кухни: id[kitchen_area] кв.м}'
    },
    sale_price_total : {
        title : 'Цена за объект',
        mask  : '{цена: id[sale_price_total] рублей}'
    },
    sale_price_square_meter : {
        title : 'Цена за кв.м.',
        mask  : '{цена: id[sale_price_square_meter] рублей за кв.м.}'
    },
    rent_price_total : {
        title : 'Цена аренды',
        mask  : '{цена аренды: id[rent_price_total] рублей}'
    },
    rent_price_square_meter : {
        title : 'Цена аренды за кв.м.',
        mask  : '{цена аренды: id[rent_price_square_meter] рублей за кв.м.}'
    },
    is_free_layout : {
        title : 'Свободная планировка',
        mask  : '{id[is_free_layout] свободная планировка}'
    },
    each_room_area : {
        title : 'Площади по комнатам',
        mask  : '{площадь комнат: id[each_room_area] кв.м.}'
    },
    height_of_ceilings : {
        title : 'Высота потолков',
        mask  : '{высота потолков: id[height_of_ceilings]}'
    },
    count_of_separated_bathrooms : {
        title : 'Количество раздельных санузлов',
        mask  : '{раздельных санузлов: id[count_of_separated_bathrooms]}'
    },
    count_of_combained_bathrooms : {
        title : 'Количество совмещенных санузлов',
        mask  : '{совмещенных санузлов: id[count_of_combained_bathrooms]}'
    },
    count_of_balconies : {
        title : 'Количество балконов',
        mask  : '{балконов: id[count_of_balconies]}'
    },
    count_of_loggias : {
        title : 'Количество лоджий',
        mask  : '{лоджий: id[count_of_loggias]}'
    },
    windows_overlook_street : {
        title : 'Окна выходят на улицу',
        mask  : '{id[windows_overlook_street]окна выходят на улицу}'
    },
    windows_overlook_yard : {
        title : 'Окна выходят во двор',
        mask  : '{id[windows_overlook_yard]окна выходят во двор}'
    },
    has_action : {
        title : 'Акция',
        mask  : '{id[has_action] Действует акция, подробности уточняйте в отделе продаж.}'
    },
    action_description : {
        title : 'Описание акции',
        mask  : '{описание акции: id[action_description]}'
    },
    number : {
        title : 'Номер квартиры/офиса',
        mask  : '{номер помещения: id[number]}'
    },
    commerce_type : {
        title : 'Основное назначение помещения',
        mask  : '{основное назначение: id[commerce_type]}'
    },
    commerce_type_additional : {
        title : 'Дополнительные назначения помещения',
        mask  : '{дополнительные назначения: id[commerce_type_additional]}'
    },
    has_own_entrance_group : {
        title : 'Наличие собственной входной группы',
        mask  : '{id[has_own_entrance_group] собственная входная группа}'
    }
}